import {Routes} from './routes.constants';

export default function isWelcomeRoute(pathname: string) {
  return pathname.startsWith(Routes.Welcome);
}
